import {defineSlotRecipe} from '@chakra-ui/react3'

export default defineSlotRecipe({
    slots: ['container', 'price', 'listPrice'],
    base: {
        container: {
            display: 'inline-grid',
            gridAutoFlow: {base: 'row', xs: 'column'},
            justifyItems: 'start',
            alignItems: 'baseline',
            columnGap: 'spacing-6',
            flex: '0 1 auto',
            width: 'max-content',
            maxWidth: '100%'
        },
        price: {
            whiteSpace: 'nowrap'
        },
        listPrice: {
            textDecoration: 'line-through',
            whiteSpace: 'nowrap',
            textStyle: 'heading.small',
            paddingLeft: 'spacing-4',
            paddingRight: 'spacing-4',
            borderRadius: 'xs',
            bg: 'background.actions.ghost',
            color: 'text.secondary'
        }
    },
    variants: {
        layout: {
            inline: {
                container: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    flex: '1 1 auto',
                    minWidth: 'min-content',
                    width: 'auto'
                }
            }
        },
        variant: {
            primary: {
                price: {
                    color: 'text.primary',
                    textStyle: 'body.medium'
                }
            },
            // teaser context: replicates old plain variant's glass-pill root (paddingX: 0, paddingY from base)
            secondary: {
                container: {
                    columnGap: 'spacing-4'
                },
                price: {
                    color: 'text.secondary',
                    textStyle: 'heading.medium'
                },
                listPrice: {
                    textStyle: 'body.small'
                }
            },
            // used inside PriceButtonGroup: no extra padding (glass-pill root provides it)
            'on-media': {
                listPrice: {
                    color: 'inherit'
                }
            },
            // navigation card context: both prices sit on the card's body.xsmall scale
            compact: {
                container: {
                    columnGap: 'spacing-4',
                    // force single row even at base breakpoint, overriding base's row/column responsive switch, so price and listPrice never stack in the narrow nav card
                    gridAutoFlow: 'column'
                },
                price: {
                    textStyle: 'body.xsmall'
                },
                listPrice: {
                    textStyle: 'body.xsmall'
                }
            }
        }
    },
    defaultVariants: {}
})
